// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Search highlighting styles */
.search-highlight {
  background-color: #fef3c7; /* Light yellow background */
  color: #92400e; /* Dark amber text */
  padding: 0.125rem 0.25rem;
  border-radius: 0.25rem;
  font-weight: 600;
  box-decoration-break: clone;
  -webkit-box-decoration-break: clone;
}

/* Alternative highlight styles for different contexts */
.search-highlight-primary {
  background-color: #dbeafe; /* Light blue background */
  color: #1e40af; /* Dark blue text */
  padding: 0.125rem 0.25rem;
  border-radius: 0.25rem;
  font-weight: 600;
}

.search-highlight-success {
  background-color: #d1fae5; /* Light green background */
  color: #065f46; /* Dark green text */
  padding: 0.125rem 0.25rem;
  border-radius: 0.25rem;
  font-weight: 600;
}

/* Subtle highlight for less prominent matches */
.search-highlight-subtle {
  background-color: #f3f4f6; /* Light gray background */
  color: #374151; /* Dark gray text */
  padding: 0.125rem 0.25rem;
  border-radius: 0.25rem;
  font-weight: 500;
  border: 1px solid #d1d5db;
}

/* Highlight with animation for newly matched items */
.search-highlight-animated {
  background-color: #fef3c7;
  color: #92400e;
  padding: 0.125rem 0.25rem;
  border-radius: 0.25rem;
  font-weight: 600;
  animation: highlightFadeIn 0.3s ease-in-out;
}

@keyframes highlightFadeIn {
  0% {
    background-color: #fbbf24;
    transform: scale(1.05);
  }
  100% {
    background-color: #fef3c7;
    transform: scale(1);
  }
}

/* Ensure highlighting works well in different contexts */
.source-name .search-highlight,
.source-identifier .search-highlight {
  font-weight: 600;
}

.source-category .search-highlight {
  background-color: #ede9fe; /* Light purple for categories */
  color: #5b21b6; /* Dark purple text */
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .search-highlight {
    background-color: #000000;
    color: #ffffff;
    border: 1px solid #ffffff;
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  .search-highlight-animated {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/utils/search-highlight.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,yBAAyB,EAAE,4BAA4B;EACvD,cAAc,EAAE,oBAAoB;EACpC,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA,wDAAwD;AACxD;EACE,yBAAyB,EAAE,0BAA0B;EACrD,cAAc,EAAE,mBAAmB;EACnC,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;EACtD,cAAc,EAAE,oBAAoB;EACpC,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,yBAAyB,EAAE,0BAA0B;EACrD,cAAc,EAAE,mBAAmB;EACnC,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,qDAAqD;AACrD;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE;IACE,yBAAyB;IACzB,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;AACF;;AAEA,yDAAyD;AACzD;;EAEE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB,EAAE,gCAAgC;EAC3D,cAAc,EAAE,qBAAqB;AACvC;;AAEA,+BAA+B;AAC/B;EACE;IACE,yBAAyB;IACzB,cAAc;IACd,yBAAyB;EAC3B;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Search highlighting styles */\n.search-highlight {\n  background-color: #fef3c7; /* Light yellow background */\n  color: #92400e; /* Dark amber text */\n  padding: 0.125rem 0.25rem;\n  border-radius: 0.25rem;\n  font-weight: 600;\n  box-decoration-break: clone;\n  -webkit-box-decoration-break: clone;\n}\n\n/* Alternative highlight styles for different contexts */\n.search-highlight-primary {\n  background-color: #dbeafe; /* Light blue background */\n  color: #1e40af; /* Dark blue text */\n  padding: 0.125rem 0.25rem;\n  border-radius: 0.25rem;\n  font-weight: 600;\n}\n\n.search-highlight-success {\n  background-color: #d1fae5; /* Light green background */\n  color: #065f46; /* Dark green text */\n  padding: 0.125rem 0.25rem;\n  border-radius: 0.25rem;\n  font-weight: 600;\n}\n\n/* Subtle highlight for less prominent matches */\n.search-highlight-subtle {\n  background-color: #f3f4f6; /* Light gray background */\n  color: #374151; /* Dark gray text */\n  padding: 0.125rem 0.25rem;\n  border-radius: 0.25rem;\n  font-weight: 500;\n  border: 1px solid #d1d5db;\n}\n\n/* Highlight with animation for newly matched items */\n.search-highlight-animated {\n  background-color: #fef3c7;\n  color: #92400e;\n  padding: 0.125rem 0.25rem;\n  border-radius: 0.25rem;\n  font-weight: 600;\n  animation: highlightFadeIn 0.3s ease-in-out;\n}\n\n@keyframes highlightFadeIn {\n  0% {\n    background-color: #fbbf24;\n    transform: scale(1.05);\n  }\n  100% {\n    background-color: #fef3c7;\n    transform: scale(1);\n  }\n}\n\n/* Ensure highlighting works well in different contexts */\n.source-name .search-highlight,\n.source-identifier .search-highlight {\n  font-weight: 600;\n}\n\n.source-category .search-highlight {\n  background-color: #ede9fe; /* Light purple for categories */\n  color: #5b21b6; /* Dark purple text */\n}\n\n/* High contrast mode support */\n@media (prefers-contrast: high) {\n  .search-highlight {\n    background-color: #000000;\n    color: #ffffff;\n    border: 1px solid #ffffff;\n  }\n}\n\n/* Reduced motion support */\n@media (prefers-reduced-motion: reduce) {\n  .search-highlight-animated {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
